<!-- OverlayQueue.vue -->
<template>
  <div v-if="overlayConfig">
    <OverlayDialog
      :config="overlayConfig"
      @close="handleClose"
      @button-action="handleButton"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import overlayQueue from '@/i12e/services/overlayQueue';
import OverlayDialog from './OverlayDialog.vue';

const overlayConfig = ref(null);

function updateOverlay() {
  // The host always renders the next queued overlay, regardless of whether it
  // is a simple message dialog or a richer interactive component.
  overlayConfig.value = overlayQueue.popOverlay();
}

onMounted(() => {
  updateOverlay();
  overlayQueue.addEventListener(
    overlayQueue.getOverlayPushedEventName(),
    updateOverlay
  );
});

onBeforeUnmount(() => {
  overlayQueue.removeEventListener(
    overlayQueue.getOverlayPushedEventName(),
    updateOverlay
  );
});

function handleClose() {
  if (typeof overlayConfig.value?.closeAction === 'function') {
    overlayConfig.value.closeAction();
  }
  updateOverlay();
}

function handleButton(btn) {
  if (typeof btn?.action === 'function') {
    btn.action();
  }
  handleClose();
}
</script>

<style scoped>
/* Additional styling if needed */
</style>
